import React, { Component } from 'react';
import PropTypes from 'prop-types';
import TranslationContainer from '../../../../translation/translation_container';
import Select from '../../../../form/floating_label/select';
import { getDefaultValueForFilter } from '../../../../../helper/filters/get_default_value_for_filter';
import RegoLookupStore from '../../../../../stores/rego_lookup_store';
import VehicleFilterStore from '../../../../../stores/vehicle_configurator_store';
import {Filters} from '../../../../../constants/filter/filters';
import VehicleCatalogFilterOptionsStore from '../../../../../stores/catalog_filter_options_store/vehicle';

class LightboxVehicleFilterSelect extends Component {
    constructor() {
        super();
        this.state = {
            regoLookupStore: RegoLookupStore.getState(),
            vehicleConfiguratorStore: VehicleFilterStore.getState(),
            vehicleCatalogFilterOptionsStore: VehicleCatalogFilterOptionsStore.getState(),
        };
    }

    componentDidMount() {
        RegoLookupStore.addListener(() => this._getRegoLookupStore());
        VehicleFilterStore.addListener(() => this._getVehicleConfiguratorStore());
        VehicleCatalogFilterOptionsStore.addListener(() => this._getVehicleFilterOptionsStore());
    }

    componentWillUnmount() {
        RegoLookupStore.addListener(() => this._getRegoLookupStore());
        VehicleFilterStore.addListener(() => this._getVehicleConfiguratorStore());
        VehicleCatalogFilterOptionsStore.addListener(() => this._getVehicleFilterOptionsStore());
    }

    _getVehicleFilterOptionsStore() {
        this.setState({
            vehicleCatalogFilterOptionsStore: VehicleCatalogFilterOptionsStore.getState(),
        });
    }

    _getRegoLookupStore() {
        this.setState({
            regoLookupStore: RegoLookupStore.getState(),
        });
    }

    _getVehicleConfiguratorStore() {
        this.setState({
            vehicleConfiguratorStore: VehicleFilterStore.getState(),
        });
    }

    render() {
        const props = this.props;
        const {regoLookupStore, vehicleConfiguratorStore, vehicleCatalogFilterOptionsStore} = this.state;
        let vehicleFilterValue = '';
        let vehicleFilterTyreOptions = [];
        if (vehicleCatalogFilterOptionsStore.tyres.length > 0) {
            vehicleFilterValue = vehicleConfiguratorStore.values[Filters.VEHICLE_TYRES];
            vehicleFilterTyreOptions = vehicleCatalogFilterOptionsStore.tyres;
        } else if(regoLookupStore.vehicleData.length > 0) {
            vehicleFilterValue = regoLookupStore.values[Filters.VEHICLE_TYRES];
            for (let i = 0; i < regoLookupStore.vehicleData.length; i++) {
                if (regoLookupStore.values[Filters.VEHICLE_ID] === regoLookupStore.vehicleData[i][Filters.VEHICLE_ID]) {
                    vehicleFilterTyreOptions = regoLookupStore.vehicleData[i][Filters.VEHICLE_TYRES];
                    break;
                }
            }
        }
        return (
            <div className="lightbox-filter-section__filter">
                <TranslationContainer
                    targetProperties={{
                        label: {translationKey: props.labelTranslationKey},
                        provideAllTranslationKey: {translationKey: props.provideAllTranslationKey},
                    }}
                >
                    <Select
                        name={props.name}
                        label="will-be-replaced"
                        value={vehicleFilterValue}
                        hasValue={getDefaultValueForFilter(props.name) !== vehicleFilterValue}
                        options={vehicleFilterTyreOptions}
                        onChange={props.onChange}
                        provideAllOption={true}
                        disabled={props.disabled}
                        highlight={true}
                        loading={props.loading}
                    />
                </TranslationContainer>
            </div>
        );
    }
}

LightboxVehicleFilterSelect.propTypes = {
    name: PropTypes.string.isRequired,
    labelTranslationKey: PropTypes.string.isRequired,
    provideAllTranslationKey: PropTypes.string.isRequired,
    onChange: PropTypes.func.isRequired,
    provideAllOption: PropTypes.bool.isRequired,
    disabled: PropTypes.bool,
    loading: PropTypes.bool,
};

LightboxVehicleFilterSelect.defaultProps = {
    disabled: false,
    loading: false,
};

export { LightboxVehicleFilterSelect };
